module.exports = __webpack_public_path__ + "static/media/icon-list-check.96bb44d8.svg";